import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    user: {},
    token: '',
    products: [],
    checkout: {
        profile: {},
        address: {
          billing_address: {},
          shipping_address: {}
        },
        payment: {},
        order: {},
        shipping_type: ''
      },
    cart: [],
    logged: false,
    is_partner: false,
    is_loading: false,
    loading_label: 'Carregando...',
  },
  actions: {
    addProductToCart(context, product){
      const cartItem = context.state.cart.find(item => item.id === product.id)
      if(!cartItem){
        context.commit('pushProductToCart', product)
      } else {
        context.commit('incrementItemQuantity', cartItem)
      }
    },
    subtractProductToCart(context, product){
      const cartItem = context.state.cart.find(item => item.id === product.id)
      if(cartItem){
        context.commit('subtractItemQuantity', cartItem)
      }
    },
    cleanCart(context){
      localStorage.removeItem('cart');
      context.commit('cleanCart')
    }
  },
  mutations: {
    cleanCart(state){
      state.cart = []
    },
    cleanCheckout(state){
      state.checkout = {
        profile: {},
        address: {
          billing_address: {},
          shipping_address: {}
        },
        payment: {},
        order: {}
      }
    },
    setToken(state, newToken){
      localStorage.setItem('token', newToken)
      state.token = newToken
      if(newToken) {
        state.logged = true
      }
    },
    setLoading(state, is_loading){
      state.is_loading = is_loading
    },
    setCartImage(state, data){
      console.log(state)
      console.log(data)
    },
    setUser(state, user_data){

      let oldUser = localStorage.getItem("user")
      if(oldUser) user_data = JSON.parse(oldUser)
        else localStorage.setItem('user', JSON.stringify(user_data))

      if(state.user.email)
        if(state.user.email != user_data.user.email){
          user_data.user.email = state.user.email
          localStorage.setItem('user', JSON.stringify(user_data))
        }


      if(user_data) {
        let user = {
          id: user_data.id,
          email: user_data.user.email,
          name: user_data.name,
          company_name: user_data.company_name,
          person_or_company: user_data.person_or_company,
          phone: user_data.phone,
          cnpj: user_data.cnpj,
          cpf: user_data.cpf,
          ie: user_data.ie,
          is_superuser: user_data.user.is_superuser,
          is_staff: user_data.user.is_staff,
          is_partner: user_data.is_partner
        }

        state.is_partner = user.is_partner
        state.user = user

        state.checkout.profile = user
        state.checkout.address = {
            billing_address: user_data.billing_address,
            shipping_address: user_data.shipping_address
          }

      }
    },
    logout(state){
      this.commit('cleanCheckout')
      localStorage.clear();
      state.token = ''
      state.user = {}
      state.cart = []
      state.logged = false
      state.is_partner = false
    },
    pushProductToCart(state, product){
      if(state.cart != null && state.cart.length === 0){
        var cart = JSON.parse(localStorage.getItem("cart"));
        if(cart != null) state.cart = cart
      }
      state.cart.push({
        id: product.id,
        name: product.name,
        price: product.price,
        weight: product.weight,
        has_airplane_info: product.has_airplane_info,
        has_photo_upload: product.has_photo_upload,
        is_download: product.is_download,
        file: '',
        file_path: '',
        quantity: 1
      })
      localStorage.setItem('cart', JSON.stringify(state.cart))
    },
    incrementItemQuantity(state, cartItem){
      cartItem.quantity = cartItem.quantity + 1
    },
    subtractItemQuantity(state, cartItem){
      if(cartItem.quantity > 1)
        cartItem.quantity = cartItem.quantity - 1
    },
    deleteFromCart(state, i){
      state.cart.splice(i, 1)
      localStorage.setItem('cart', JSON.stringify(state.cart))
    },
    updateCheckout (state, checkout) {
      state.checkout = checkout
    },
    updateLoadingLabel (state, label) {
      state.loading_label = label
    }
  },
  getters: {
    isSuperuser(state){
      return state.user.is_superuser
    },
    isStaff(state){
      return state.user.is_staff
    },
    getUser(state){
      return state.user
    },
    getToken(state){
      return state.token
    },
    getCart(state){
      if(state.cart != null && state.cart.length == 0){
        var cart = JSON.parse(localStorage.getItem("cart"));
        if(cart != null) state.cart = cart
      }
      return state.cart
    },
    getCartNumberItems(state){
      if(state.cart != null && state.cart.length == 0){
        var cart = JSON.parse(localStorage.getItem("cart"));
        if(cart != null) state.cart = cart
      }
      if(state.cart != null){
        return state.cart.length
      } else {
        return 0
      }
    }
  }
})

export default store
